import React from 'react';
import { Box } from '@mui/material';
import PhotoLikeButton from '../../common/PhotoLikeButton';
import type { GalleryPhoto } from '../GalleryGrid';

export interface CinematicHeroProps {
   photo: GalleryPhoto;
   onClick: () => void;
   currentUser?: { uid: string } | null;
   albumId?: string;
}

export default function CinematicHero({ photo, onClick, currentUser, albumId }: CinematicHeroProps) {
   return (
      <Box
         sx={{
            width: '100%',
            mb: 2,
            borderRadius: 3,
            overflow: 'hidden',
            maxHeight: '50vh',
            cursor: 'pointer',
            position: 'relative',
            border: '1px solid',
            borderColor: 'grey.300',
            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
            '&:hover .cinematic-hero-img': {
               transform: 'scale(1.01)',
            },
            '&:hover .cinematic-hero-like': {
               opacity: 1,
            },
            transition: 'box-shadow 0.3s ease',
            '&:hover': {
               boxShadow: 6,
            },
         }}
         onClick={onClick}
      >
         <Box
            className='cinematic-hero-img'
            component='img'
            src={
               photo.mediaType === 'video'
                  ? (photo.thumbnailUrl || '')
                  : (photo.url || photo.thumbnailUrl)
            }
            alt={photo.title || ''}
            loading='lazy'
            sx={{
               width: '100%',
               aspectRatio: '16 / 9',
               '@media (max-width: 640px)': { aspectRatio: '4 / 3' },
               objectFit: 'cover',
               display: 'block',
               transition: 'transform 0.3s ease-out',
            }}
         />
         {currentUser && (
            <Box
               className="cinematic-hero-like"
               onClick={(e) => e.stopPropagation()}
               sx={{
                  position: 'absolute',
                  bottom: 12,
                  right: 12,
                  zIndex: 2,
                  opacity: 0,
                  transition: 'opacity 0.2s ease',
               }}
            >
               <PhotoLikeButton
                  photoId={photo.id}
                  userId={currentUser.uid}
                  initialLikeCount={photo.likeCount ?? 0}
                  initialIsLiked={photo.isLiked ?? false}
                  albumId={albumId}
                  size="small"
                  variant="compact"
                  showCount
               />
            </Box>
         )}
      </Box>
   );
}
